// Парные часы для коротких гейтов текущей вкладки (throttle / probe / focus).
// Стена (Date.now) переживает сон вкладки; монотонное (performance.now) —
// скачок системных часов назад. Штамп живёт только в памяти, в LS не кладём.

/**
 * @returns {{ wall: number, mono: number | null }}
 */
export function stampNow() {
  return {
    wall: Date.now(),
    mono: typeof performance !== 'undefined' && typeof performance.now === 'function'
      ? performance.now()
      : null,
  };
}

/**
 * Сколько мс прошло с `stamp`. Нет штампа / прыжок стены назад без монотонного
 * → Infinity (гейт открыт), а не отрицательное «окно на часы».
 *
 * @param {null | undefined | number | { wall: number, mono?: number | null }} stamp
 * @returns {number}
 */
export function elapsedSince(stamp) {
  if (stamp == null || stamp === 0) return Infinity;
  if (typeof stamp === 'number') {
    const d = Date.now() - stamp;
    return d < 0 ? Infinity : d;
  }
  const wallD = Date.now() - stamp.wall;
  if (stamp.mono != null
      && typeof performance !== 'undefined'
      && typeof performance.now === 'function') {
    return Math.max(wallD, performance.now() - stamp.mono);
  }
  return wallD < 0 ? Infinity : wallD;
}
